import React, { useRef, useEffect, forwardRef } from 'react'
import Modal from 'react-modal'

import {
  MoreButton,
  MenuActions,
  MenuActionItems,
  MenuActionItemsMobile,
  MenuActionItem,
  MenuActionItemMobile,
  ShareLink,
} from './styled'

import OrderPartyLinkIcon from './OrderPartyLinkIcon'
import OrderPartyMoreIcon from './OrderPartyMoreIcon'
import OrderPartyOpenIcon from './OrderPartyOpenIcon'

import { DesktopScreen, MobileScreen } from 'utils/screen'

const DropdownButton = forwardRef((props, ref) => {
  return (
    <MoreButton {...props} ref={ref} data-id="party-v2-menu">
      <OrderPartyOpenIcon />
    </MoreButton>
  )
})

function ActionsForDesktop({
  isLoggedIn = false,
  isMember = false,
  isOpen = false,
  onLeave = () => {},
  isLeader = false,
  onRequestLogin = () => {},
  onShare = () => {},
  setIsOpen = () => {},
  shareLink = '',
}) {
  const menuRef = useRef(null)
  const buttonRef = useRef(null)
  const shareLinkRef = useRef(null)

  function handleClick(evt) {
    const isButton = evt.target.getAttribute('data-id') === 'party-v2-menu'

    const isInsideButton = buttonRef.current.contains(evt.target)

    if (isButton || isInsideButton) {
      if (!isLoggedIn) return onRequestLogin()

      if (isMember) setIsOpen(!isOpen)
    }

    const isInSideMenu = menuRef.current.contains(evt.target)

    if (isInSideMenu) return evt.preventDefault()

    setIsOpen(false)
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [isMember])

  const handleShare = () => {
    shareLinkRef.current.select()
    document.execCommand('copy')
    onShare()
  }

  return (
    <MenuActions ref={menuRef}>
      <DropdownButton ref={buttonRef} />
      {isOpen && (
        <MenuActionItems>
          <MenuActionItem onClick={handleShare}>
            <OrderPartyLinkIcon />
            <span>Share</span>
          </MenuActionItem>
          <MenuActionItem onClick={onLeave}>
            <OrderPartyMoreIcon />
            <span>{isLeader ? 'Delete Party' : 'Leave Party'}</span>
          </MenuActionItem>
          <ShareLink ref={shareLinkRef} value={shareLink} readOnly />
        </MenuActionItems>
      )}
    </MenuActions>
  )
}

function ActionsForMobile({
  isLoggedIn = false,
  isMember = false,
  isOpen = false,
  isLeader = false,
  onLeave = () => {},
  onRequestLogin = () => {},
  onShare = () => {},
  setIsOpen = () => {},
  shareLink = '',
}) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
  }, [isOpen])

  const shareLinkRef = useRef(null)

  const handleShare = () => {
    shareLinkRef.current.select()
    document.execCommand('copy')
    onShare()
  }

  const handleDropdownClick = () => {
    if (!isLoggedIn) return onRequestLogin()

    if (isMember || isLeader) setIsOpen(true)
  }

  return (
    <MenuActions>
      <DropdownButton onClick={handleDropdownClick} />
      <Modal
        isOpen={isOpen}
        contentLabel="Order Party"
        onRequestClose={() => setIsOpen(false)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 4000,
          },
          content: {
            height: '120px',
            padding: 0,
            border: 'none',
            borderRadius: 0,
            top: 'auto',
            left: 0,
            right: 0,
            bottom: 0,
          },
        }}
      >
        <MenuActionItemsMobile>
          <MenuActionItemMobile onClick={handleShare}>
            <OrderPartyLinkIcon />
            <span>Share</span>
          </MenuActionItemMobile>
          <MenuActionItemMobile onClick={onLeave}>
            <OrderPartyMoreIcon />
            <span>{isLeader ? 'Delete Party' : 'Leave Party'}</span>
          </MenuActionItemMobile>
          <ShareLink ref={shareLinkRef} value={shareLink} />
        </MenuActionItemsMobile>
      </Modal>
    </MenuActions>
  )
}

export const ActionMenuMobile = props => (
  <MobileScreen>
    <ActionsForMobile {...props} />
  </MobileScreen>
)

export const ActionMenuDesktop = props => (
  <DesktopScreen>
    <ActionsForDesktop {...props} />
  </DesktopScreen>
)
